import { MenuItem, TextField, useTheme } from "@mui/material";

export default function SupplierFilterSelect({ suppliers = [], onChange, defaultValue = "all" }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const cardBg = isDark ? "rgba(255,255,255,0.03)" : "#ffffff";
  const border = isDark ? "rgba(29,158,117,0.14)" : "rgba(29,158,117,0.16)";

  const inputSx = {
    width: "180px",
    "& .MuiInputBase-root": { fontSize: "13px", height: "36px", backgroundColor: cardBg, borderRadius: "8px" },
    "& .MuiOutlinedInput-notchedOutline": { borderColor: border },
    "& .MuiInputLabel-root": { fontSize: "12px" },
  };

  return (
    <TextField
      label="Supplier"
      size="small"
      select
      defaultValue={defaultValue}
      onChange={(e) => onChange(e.target.value)}
      sx={inputSx}
    >
      <MenuItem value="all">All suppliers</MenuItem>
      {suppliers.map((s) => (
        <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
      ))}
    </TextField>
  );
}
